import type { SVGProps } from 'react';

export function MeepleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2c2.486 0 3.713 1.766 3.955 4.1l.01.124.129.036c3.17.928 5.754 2.487 5.9 4.556L22 11c0 1.427-1.297 2.322-2.871 2.733l-.201.049.026.03c.244.276.532.603.7.797l.057.066c.49.573.884 1.073 1.216 1.56C21.617 17.245 22 18.139 22 19a2 2 0 0 1-2 2h-5c-1.043 0-1.344-.453-2.394-2.553-.29-.58-.448-.882-.593-1.118L12 17.307l-.013.022c-.129.21-.268.472-.5.935l-.093.183C10.344 20.547 10.043 21 9 21H4a2 2 0 0 1-2-2c0-.86.384-1.755 1.073-2.765q.564-.814 1.216-1.56c.152-.178.482-.553.757-.863l.025-.03-.2-.049c-1.506-.393-2.758-1.23-2.864-2.55L2 11c0-2.16 2.643-3.785 5.906-4.74l.128-.036.011-.124c.235-2.26 1.394-3.99 3.726-4.095z" />
    </svg>
  );
}
